import {
  CompareItem,
  CompareLocale,
} from '_components/Product/ProductCompareTable/types';

export type AttributeType =
  | 'name'
  | 'price'
  | 'rating'
  | 'cta'
  | 'idealFor'
  | 'techspec';

const NAME_KEYS = ['name', 'nom'];
const PRICE_KEYS = ['price', 'prix'];
const RATING_KEYS = ['rating', 'évaluations'];
const CTA_KEYS = ['cta'];
// Matched on letters only, so the Akeneo code (`ideal_for`) and the EN/FR
// labels ("Ideal for", "Idéal pour") all resolve to the same attribute.
const IDEAL_FOR_KEYS = ['idealfor', 'idealpour'];

const toLetters = (key: string): string =>
  key
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z]/g, '');

export function getAttributeType(specKey: string): AttributeType {
  const key = specKey.toLowerCase();
  if (NAME_KEYS.includes(key)) return 'name';
  if (PRICE_KEYS.includes(key)) return 'price';
  if (RATING_KEYS.includes(key)) return 'rating';
  if (CTA_KEYS.includes(key)) return 'cta';
  if (IDEAL_FOR_KEYS.includes(toLetters(key))) return 'idealFor';
  return 'techspec';
}

export function getCompareSpecArray(
  item: CompareItem,
  code: string,
  locale: CompareLocale
): string[] | null {
  const val = item.comparisonSpecs?.[code]?.[locale];
  if (!val) return null;
  const items = (Array.isArray(val) ? val : [val]).filter(
    (entry) => !!entry && entry !== '0'
  );
  return items.length > 0 ? items : null;
}

export function getCompareSubtitleArray(
  item: CompareItem,
  locale: CompareLocale,
  labelPrefix?: string
): string[] {
  const val = item.subtitle?.[locale];
  if (!val) return [];
  const prefix = labelPrefix?.trim().toLowerCase();
  return (Array.isArray(val) ? val : [val])
    .filter((entry): entry is string => typeof entry === 'string')
    .map((entry) => {
      const trimmed = entry.trim();
      if (!prefix || !trimmed.toLowerCase().startsWith(prefix)) return trimmed;
      return trimmed.slice(prefix.length).trim();
    })
    .filter(Boolean);
}

export function formatList(items: string[], conjunction: string): string {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} ${conjunction} ${items[1]}`;
  return `${items.slice(0, -1).join(', ')} ${conjunction} ${
    items[items.length - 1]
  }`;
}
